// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__252PX","label":"Completed_label__2HcQg"};